export default __webpack_public_path__ + "static/1387-46e17d71fdfcaf0f2b8368b5bd8df2fe.gif";